import React from 'react';
import { Button } from "react-bootstrap";
import userpic from '../../assets/user-default.png';

const NBAstatsPlayerRow = (player, position, handlePlayerModalShow) => {

  const data={
    playerId:player.player_id ? player.player_id : null,
    team: player.team_key,
    position:position?.title,
    className:position?.className
  }

    return (
        <div className={"standing-card stat-card " + position.className}>
            <div className="player-info">
                <figure>{player.player_img_url && player.player_img_url != '' ?<img src={player.player_img_url} alt="KO" /> : <img src={userpic} alt="KO" />}</figure>
                <div className="name">{player.player_full_name}</div>
            </div>
            <div className="standing-stats">
                <div className="stat-value game-value">
                    <div class="game-group">
                      <label>Game</label><p> 
                        {player.opponent_team_key ? player.opponent_team_key : ""} 
                        { player.team_key && player.opponent_team_key ? ' @ ' : "-"}
                        {player.team_key ? player.team_key : ""}
                        </p>
                    </div>
                </div>
                <div className="stat-value">
            <label>Score</label><p>{player.totalScore ? player.totalScore : '0'}</p>
          </div> 

          <Button variant="primary" onClick={() => handlePlayerModalShow(data)} className="stats-btn">Player Stats</Button>

            </div>
        </div>
    );
};

const NBAplayerPosition = (user_game) => {
     const playerPos = [
        {
            "code": "C",
            "title": "Center",
            "h4": "Center",
            "eventKey": "quarterback",
            "className": "quarterback"
        },
        {
            "code": "F",
            "title": "Forward",
            "h4": "Forward",
            "eventKey": "runningback",
            "className": "runningback"
        },
        {
            "code": "G",
            "title": "Guard",
            "h4": "Guard",
            "eventKey": "widereceivers",
            "className": "widereceiver"
        },
        {
            "code": "FC",
            "title": "Forward/Center",
            "h4": "Forward/Center",
            "eventKey": "tightend",
            "className": "tightend"
        },
        {
            "code": "GF",
            "title": "Guard/Forward",
            "h4": "Guard/Forward",
            "eventKey": "flexplayer",
            "className": "flexplayer"
        },
       
    ]
    return playerPos
};

export { NBAstatsPlayerRow, NBAplayerPosition };